import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import { iterate } from '../util';
import t from '@instructure/quiz-i18n/format-message';
export var noDuplicates = function noDuplicates(obj, options) {
  if (!obj) {
    return;
  }
  var field = options.field;
  var getter = field ? function (val) {
    return val[field];
  } : function (val) {
    return val;
  };
  var createMessage;
  if (field) {
    createMessage = function createMessage(msg) {
      return _defineProperty({}, field, [msg]);
    };
  } else {
    createMessage = function createMessage(msg) {
      return msg;
    };
  }
  var message = options.message || t('duplicate');
  var usedVals = {};
  var errors = {};
  iterate(obj, function (item, key) {
    var val = getter(item) && getter(item).trim();
    if (usedVals.hasOwnProperty(val)) {
      errors[key] = createMessage(message);
    } else {
      usedVals[val] = true;
    }
  });
  return errors;
};
export default noDuplicates;